module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Sushi-1003c89b9f86bc26e19813409ea05af3.svg";